import { Navigate, Outlet } from "react-router";

import { AppBreadcrumb } from "@/components/app-breadcrumb";
import { AppSidebar } from "@/components/app-sidebar";
import { OfflineBanner } from "@/components/offline-banner";
import { StagingBanner } from "@/components/staging-banner";
import { SidebarProvider } from "@/components/ui/sidebar";
import { useAppStatus } from "@/hooks/use-banner-data";
import { cn } from "@/lib/utils";
import useStore from "@/state";

export const DashboardLayout = () => {
  const { session } = useStore();
  const { showBanner } = useAppStatus();

  if (!session) {
    return <Navigate to="/" />;
  } else if (!session.organization_id) {
    return <Navigate to="/no-organization" />;
  }

  return (
    <SidebarProvider>
      <OfflineBanner />
      <StagingBanner />
      <AppSidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <AppBreadcrumb />
        <div
          className={cn(
            "flex flex-1 flex-col px-12 py-8",
            showBanner ? "mt-23" : "mt-15",
          )}
        >
          <Outlet />
        </div>
      </div>
    </SidebarProvider>
  );
};
